import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import CenterSpinner from './CenterSpinner';
import { useAppDispatch } from '../store/redux-hooks';
import {
  getPowerBIReportAccess,
  getReportDetails,
} from '../features/powerBiSlice';
import { useLoader } from '../loader/LoaderProvider';

interface IEmbededPowerBiProps {
  groupId: string;
  reportId: string;
}

const EmbededPowerBi: React.FunctionComponent<IEmbededPowerBiProps> = ({
  groupId,
  reportId,
}) => {
  const [embededConfig, setEmbededConfig] = useState({
    id: '',
    embedUrl: '',
    accessToken: '',
    type: 'report',
    tokenType: 1,
    cssClassName: 'Embed-container',
    settings: {
      layoutType: 1,
      panes: {
        filters: {
          expanded: false,
          visible: true,
        },
      },
    },
  });
  const { showLoader, setShowLoader } = useLoader();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setShowLoader(true);
    dispatch(getReportDetails({ groupId: groupId, reportId: reportId }))
      .then((reportsDetails) => {
        dispatch(
          getPowerBIReportAccess({
            datasets: [{ id: reportsDetails.payload.datasetId }],
            reports: [{ id: reportId }],
          })
        )
          .then((accessDetails) => {
            setShowLoader(false);
            setEmbededConfig({
              ...embededConfig,
              id: reportId,
              embedUrl: reportsDetails.payload.embedUrl,
              accessToken: accessDetails.payload.token,
            });
          })
          .catch(() => {
            setShowLoader(false);
          });
      })
      .catch(() => {});
  }, []);

  return (
    <>
      {embededConfig?.id ? (
        <PowerBIEmbed
          embedConfig={embededConfig}
          cssClassName={'Embed-container'}
          getEmbeddedComponent={(embeddedReport) => {
            (window as any).report = embeddedReport;
          }}
        />
      ) : (
        ''
      )}
      <CenterSpinner showLoader={showLoader} />
    </>
  );
};

export default EmbededPowerBi;
